import { routerReducer } from "@ngrx/router-store";
import { ActionReducerMap } from "@ngrx/store";
import { contractReducers } from "../reducers/contract.reducers";
import { IAppState } from "../state/app.state";
import { benefitsReducers } from "./benefits.reducers";
import { challengesReducers } from "./challenges.reducers";
import { consumptionReducers } from "./consumption.reducers";
import { consumptionOmieReducers } from "./consumption-omie.reducers";
import { dashboardReducers } from "./dashboard.reducers";
import { edpeReducers } from "./edpe.reducers";
import { fileUploadReducers } from "./file-upload.reducers";
import { iframeReducers } from "./iframe.reducers";
import { layoutReducers } from "./layout.reducers";
import { levelsReducers } from "./levels.reducers";
import { notificationsReducers } from "./notifications.reducers";
import { readingReducers } from "./reading.reducers";
import { userReducers } from "./user.reducers";
import { supportProjectsReducers } from "./support-projects.reducers";
import { ratingReducers } from "./rating.reducers";
import { operationsReducers } from "./operations.reducers";
import { smartNowReducers } from "./smart-now.reducers";
import { technicalAssistancesReducers } from "./technical-assistances.reducers";
import { requestsAndOperationsReducers } from "./requests-and-operations.reducers";
import { deepLinkReducers } from "./depp-link.reducers";
import { energyEfficiencyReducers } from "./energy-efficiency.reducers";
import { billingReducers } from "./billing.reducers";
import { greenChoicesReducers } from "./green-choices.reducers";
import { openAreaReducers } from "./open-area.reducers";
import { languageReducers } from "./language.reducers";
import { SolarReducers } from "./solar.reducers";
import { assistanceRequestReducers } from "./assistance-request.reducers";
import { OnboardingReducers } from "./onboarding.reducers";
import { defineHouseReducers } from "./define-house.reducer";

export const appReducers: ActionReducerMap<IAppState, any> = {
    router: routerReducer,
    contracts: contractReducers,
    dashboard: dashboardReducers,
    consumption: consumptionReducers,
    omie: consumptionOmieReducers,
    readings: readingReducers,
    user: userReducers,
    iframe: iframeReducers,
    challenges: challengesReducers,
    donations: supportProjectsReducers,
    languages: languageReducers,
    layout: layoutReducers,
    benefits: benefitsReducers,
    levels: levelsReducers,
    uploadedFile: fileUploadReducers,
    edpe: edpeReducers,
    notifications: notificationsReducers,
    rating: ratingReducers,
    operations: operationsReducers,
    deepLink: deepLinkReducers,
    energyEfficiency: energyEfficiencyReducers,
    smartNow: smartNowReducers,
    requestsAndOperations: requestsAndOperationsReducers,
    technicalAssistances: technicalAssistancesReducers,
    billing: billingReducers,
    greenChoices: greenChoicesReducers,
    openArea: openAreaReducers,
    solar: SolarReducers,
    assistanceRequest: assistanceRequestReducers,
    onboarding: OnboardingReducers,
    defineHouse: defineHouseReducers,
};
